import { createUseStyles } from 'react-jss'
import { itemTextPadding } from './navbar-icon.style'

export const style = {
  userCircle: {
    marginRight: 5
  },
  userNotifications: {
    marginRight: 15
  },
  userCircleCaret: {
    marginRight: 15
  },
  userNavContainer: {
    height: '48px',
    alignItems: 'end',
    display: 'flex',
    cursor: 'pointer',
    // marginRight: '5px',
    paddingRight: '5px',
    paddingLeft: '5px',
    whiteSpace: 'nowrap',
    backgroundColor: 'white',
    paddingBottom: itemTextPadding
  },
  timeStamp: {
    color: 'var(--theme-font-alt)',
    fontStyle: 'italic'
  },
  reportTitle: {
    fontSize: '14px'
  },
  notificationPane: {
    minWidth: '250px',
    '&:hover $timeStamp': {
      color: 'white'
    }
  },
  userMenuPane: {
    minWidth: '180px'
  },
  userAvatar: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    backgroundColor: 'var(--theme-navbar-fg)',
    color: 'var(--theme-navbar-bg)',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 15,
    fontWeight: 600,
    textTransform: 'uppercase',
    marginRight: 5,
    transition: 'opacity 120ms',
    '&:hover': { opacity: 0.85 }
  }
}

export const useStyles = createUseStyles(style)
